export default {
  actualValue: 'Aktuálna hodnota',
};
